import { pageTypeList } from '@/api/pms'
const state = {
  pageTypeList: [],
  pageType: {}
}
const mutations = {
  changePageTypeList (state, val) {
    state.pageTypeList = val
    val.forEach(item => {
      state.pageType[item.typeCode] = item.typeName
    })
  }
}
const getters = {
}
const actions = {
  getPageTypeList ({ state, commit }) {
    pageTypeList().then(res => {
      commit('changePageTypeList', res.data.data)
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
